import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "./api";
import {handleResponseStatus, updateIdField, updateItem} from "./utils";

const initialState = {
    items: [],
    createStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    fetchStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    fetchByIdStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed',
    updateStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    deleteStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    pagination: {},
    error: null
};


export const fetchAllTransaction = createAsyncThunk('transaction/fetchAllTransaction', async ({
                                                                                                  scope,
                                                                                                  scopeId,
                                                                                                  roleSign,
                                                                                                  page,
                                                                                                  limit,
                                                                                              } = {}) => {
    try {
        let response;
        const params = new URLSearchParams();
        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);

        const queryString = params.toString();
        const fullParams = queryString ? `${queryString}` : '';
        response = await api.get(`/${roleSign}/transaction?id=${scopeId}&${fullParams}`);

        return {...response};
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const createTransaction = createAsyncThunk('transaction/createTransaction', async ({roleSign, scopeId, data}) => {
    try {
        const response = await api.post(`${roleSign}/transaction`, data);
        return {...response};
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const updateTransaction = createAsyncThunk('transaction/updateTransaction', async ({
                                                                                              scope,
                                                                                              scopeId,
                                                                                              roleSign,
                                                                                              data,
                                                                                              id
                                                                                          }) => {
    try {
        let response = await api.patch(`/${roleSign}/transaction/${id}?id=${scopeId}`, data);
        return {...response};
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const fetchTransactionById = createAsyncThunk('transaction/fetchTransactionById', async ({scope, roleSign, id}) => {
    try {
        let response = await api.get(`/${roleSign}/transaction/${id}`);
        return {...response};
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const deleteTransaction = createAsyncThunk('transaction/deleteTransaction',
    async ({roleSign, id}) => {
        try {
            const response = await api.delete(`/${roleSign}/transaction/${id}`);
            return {...response};
        } catch (error) {
            if (error.response) return error.response;
            throw error;
        }
    }
);

const transactionSlice = createSlice({
    name: "expenseType",
    initialState,
    reducers: {
        resetCreateStatus(state) {
            state.createStatus = 'idle';
        },
        resetUpdateStatus(state) {
            state.updateStatus = 'idle';
        },
        resetDeleteStatus(state) {
            state.deleteStatus = 'idle';
        },
    },
    extraReducers: (builder) => {
        builder

            //create Transaction
            .addCase(createTransaction.pending, (state) => {
                state.createStatus = 'loading';
            })
            .addCase(createTransaction.fulfilled, (state, action) => {
                const {createStatus, error} = handleResponseStatus(action.payload, 'createStatus');
                state.createStatus = createStatus;
                state.error = error;
            })
            .addCase(createTransaction.rejected, (state, action) => {
                state.createStatus = 'failed';
                state.error = action.error.message;
            })


            // Fetch all Tranasction
            .addCase(fetchAllTransaction.pending, (state) => {
                state.fetchStatus = 'loading';
            })
            .addCase(fetchAllTransaction.fulfilled, (state, action) => {
                const {fetchStatus, error} = handleResponseStatus(action.payload, 'fetchStatus');
                const {data, ...pagination} = action.payload.data;
                state.items = fetchStatus === "success" ? updateIdField(data) : state.items;
                state.fetchStatus = fetchStatus;
                state.pagination = pagination;
                state.error = error;
            })
            .addCase(fetchAllTransaction.rejected, (state, action) => {
                state.fetchStatus = 'failed';
                state.error = action.error.message;
            })

            // Fetch Transaction by ID
            .addCase(fetchTransactionById.pending, (state) => {
                state.fetchByIdStatus = 'loading';
            })
            .addCase(fetchTransactionById.fulfilled, (state, action) => {
                const {fetchByIdStatus, error} = handleResponseStatus(action.payload, 'fetchByIdStatus');
                state.items = fetchByIdStatus === "success" ? updateItem(action.payload.data.data, state.items) : state.items;
                state.fetchByIdStatus = fetchByIdStatus;
                state.error = error;
            })
            .addCase(fetchTransactionById.rejected, (state, action) => {
                state.fetchByIdStatus = 'failed';
                state.error = action.error.message;
            })

            // Update Transaction
            .addCase(updateTransaction.pending, (state) => {
                state.updateStatus = 'loading';
            })
            .addCase(updateTransaction.fulfilled, (state, action) => {
                const {updateStatus, error} = handleResponseStatus(action.payload, 'updateStatus');
                state.updateStatus = updateStatus;
                state.error = error;
            })
            .addCase(updateTransaction.rejected, (state, action) => {
                state.updateStatus = 'failed';
                state.error = action.error.message;
            })

            //Delete Transaction
            .addCase(deleteTransaction.pending, (state) => {
                state.deleteStatus = 'loading';
            })
            .addCase(deleteTransaction.fulfilled, (state, action) => {
                const {deleteStatus, error} = handleResponseStatus(action.payload, 'deleteStatus');
                const id = action.meta.arg.id;
                if (deleteStatus === "success") {
                    state.items = state.items.filter(item => item.id !== id);
                }
                state.deleteStatus = deleteStatus;
                state.error = error;
            })
            .addCase(deleteTransaction.rejected, (state, action) => {
                state.deleteStatus = 'failed';
                state.error = action.error.message;
            });
    }
});

export const {
    resetCreateStatus,
    resetUpdateStatus,
    resetDeleteStatus,
} = transactionSlice.actions;
export default transactionSlice.reducer;
